import React from 'react';
import './index.css';

interface LoadingProps {
  size?: number;
  className?: string;
  showBorder?: boolean;
}

export const Loading = (props: LoadingProps = {}) => {
  const { size = 30, showBorder = false } = props;

  const iconDom = () => {
    const { size = 30 } = props;
    return (
      <div
        className="loading"
        style={{
          width: size,
          height: size,
        }}
      />
    );
  };

  if (!showBorder) return iconDom();

  return <div className="loading-border">{iconDom()}</div>;
};

export default Loading;
